import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "transactions section section--mini" }

import "./DepositsView.scss";
import {computed, onMounted, ref, watch} from "vue";
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import DepositEntity from "@/entities/DepositEntity";
import Deposit from "@/components/Deposit/Deposit.vue";

interface Props{
	orderBy : 'asc' | 'desc'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DepositsView',
  props: {
    orderBy: { default: 'desc' }
  },
  setup(__props: any) {

let {api} = useApiStore();

let props = __props;

let items = ref<DepositEntity[]>([]);
let loading = ref<boolean>(false);

async function loadDeposits(){

	loading.value = true;

	let deposits = await api.getDeposits(1, 100, {
		mode : props.orderBy,
		field : 'id'
	});

	items.value = deposits.items;
	loading.value = false;

}

onMounted(loadDeposits);
watch(() => props.orderBy, loadDeposits);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
      return (_openBlock(), _createBlock(Deposit, {
        deposit: item,
        key: item.id
      }, null, 8, ["deposit"]))
    }), 128))
  ]))
}
}

})